import { render } from "./ImportXmlDetail.vue?vue&type=template&id=5454d5b5&scoped=true&ts=true"
import script from "./ImportXmlDetail.vue?vue&type=script&lang=ts"
export * from "./ImportXmlDetail.vue?vue&type=script&lang=ts"

import "./ImportXmlDetail.vue?vue&type=style&index=0&id=5454d5b5&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5454d5b5"]])

export default __exports__